let customers = {
  title: 'Clientes',
  title_s: 'Cliente',
  month: 'Clientes do Mês',
  icon: 'mdi-account-group',
  none: 'Cliente não Identificado',
  none_tip: 'Isso pode ocorrer caso a Venda esteja no modo Comanda,<br/>ou haja algum erro no cadastro do Agendamento',
  birthdays: {
    title: 'Aniversariantes',
    yesterday: 'Ontem',
    today: 'Hoje',
    tomorrow: 'Amanhã',
    today_birthday: 'Faz Aniversário Hoje'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Sem clientes',
    no_results: 'Nenhum cliente encontrado',
    no_address_results: 'Nenhum endereço encontrado',
    no_address: 'Nenhum',
    no_address_: 'Nenhum Endereço cadastrado.',
    items_per_page: 'Clientes por página',
    headers: {
      id: 'ID',
      name: 'Nome',
      phone: 'Telefone',
      birth_date: 'Data de Nascimento',
      identity: 'CPF',
      address: 'Endereço Principal',
      addresses: 'Endereços',
      action: 'Ações',
      history: 'Histórico'
    }
  },
  actions: {
    view: 'Ver',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir',
    whatsapp: 'Abrir no WhatsApp',
    call: 'Ligar'
  },
  view: {
    customer: 'Cliente',
    last_orders: {
      title: 'Últimas Vendas',
      actions: {
        view: 'Visualizar',
        repeat: 'Repetir'
      }
    },
    history: {
      created: 'Criado',
      edited: 'Editado',
      order: 'Nova Venda',
      unknown: 'Desconhecido'
    }
  },
  new: {
    title: 'Novo Cliente',
    clear: 'Limpar'
  },
  edit: {
    title: 'Editar Cliente',
    rules: {
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length <= 27) || 'O Nome deve ter menos que 27 caracteres'
      ],
      phoneRules: [
        v => (!v || v.length >= 14) || 'O Telefone deve ter no mínimo 10 caracteres'
      ],
      cpfRules: [
        v => (!v || v.length === 14) || 'O CPF deve ter 11 caracteres'
      ],
      cepRules: [
        v => (!v || v.length === 9) || 'O CEP deve ter 8 caracteres'
      ],
      addressRules: [
        v => !!v || 'Endereço é obrigatório',
        v => (v && v.length < 70) || 'O Endereço deve menos de 70 caracteres'
      ],
      numRules: [
        v => !!v || 'Número é obrigatório',
        v => (v && v.toString().length < 11) || 'O Número deve ter menos de 11 caracteres'
      ],
      compRules: [
        v => ((v && (v.length <= 30 || v.length !== 0)) || !v) || 'O Complemento deve ter menos de 30 caracteres'
      ],
      neighborhoodRules: [
        v => !!v || 'Bairro é obrigatório',
        v => (v && v.length <= 40) || 'O Bairro deve ter menos de 40 caracteres'
      ]
    }
  },
  widget: {
    noneCustomer: 'Comanda',
    none: 'Não Identificado',
    searchCustomer: 'Buscar Cliente',
    searchNewCustomer: 'Buscar/Adicionar Cliente',
    showAddress: 'Mostrar Endereço',
    hideAddress: 'Ocultar Endereço',
    resetCustomerForm: 'Limpar Formulário',
    resetCustomerSet: 'Limpar Cliente',
    confirmRegister: 'Confirmar Cadastro',
    confirmCustomer: 'Confirmar Cliente',
    switchSearch: {
      disableSearch: 'Desativar Busca Automática',
      enableSearch: 'Ativar Busca Automática'
    },
    selectCustomer: 'Selecionar Cliente',
    nameOrId: 'Nome ou ID',
    tooltip: {
      matchCustomers (length) {
        var plural = (length > 1)
        return `${(plural ? length : 'Um')} Cliente${(plural ? 's' : '')} cadastrado${(plural ? 's' : '')} combina${(plural ? 'm' : '')} com os dados informados.`
      }
    }
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Cliente',
    deleteAddressConfirm: 'Tem certeza que deseja excluir o Endereço'
  },
  messages: {
    error: {
      not_found: 'Cliente não encontrado'
    }
  }
}

export default customers
